import { createSelector } from 'reselect'

const activitySections = state => state.api.codeLists.activitySections.list

const mapForDropdown = activitySections => {
  return activitySections.filter(item =>
      item.value === 'SERVICE' || item.value === 'SKILL' || item.value === 'PHYSICAL_RECREATION')
}

export default createSelector(activitySections, mapForDropdown)
